// extracted by mini-css-extract-plugin
module.exports = {"columns":"footer-nav_columns__4etJ_"};